import { Expose } from 'class-transformer';

export default class PracticeEmploymentFormError {
  position: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}